<div class="dashboard-content" style="padding: 120px 40px 30px">
  <div class="billing-and-payments-screen">
    <!-- Top Page Heading (Matching Luqta Participants page layout with no card box) -->
    <div class="page-heading">
      <h3>{{ 'whatsapp-conversation.title' | translate }}</h3>

      <div class="heading-right">
        <!-- Search Input -->
        <div class="search">
          <input
            type="text"
            class="form-control"
            [placeholder]="'whatsapp-conversation.search-placeholder' | translate"
            [(ngModel)]="searchTerm"
            (ngModelChange)="onSearchChange()"
            autocapitalize="off"
            style="text-transform: none;"
          />
          <i class="fa-solid fa-magnifying-glass search-icon"></i>
          <i class="fa-solid fa-xmark clear-search" *ngIf="searchTerm" (click)="searchTerm = ''; onSearchChange()"></i>
        </div>

        <!-- Filter Button -->
        <button class="btn btn-light filter-btn" (click)="openFilterModal()">
          <i class="fa-solid fa-filter"></i>
          <span>{{ 'participants.filter' | translate }}</span>
          <span *ngIf="hasActiveFilters()" class="filter-active-dot" (click)="clearFilters(); $event.stopPropagation()" title="Clear Filters"></span>
        </button>


        <!-- View Mode Switcher commented out per user request -->
        <!--
        <div class="view-toggle-pill me-2">
          <button class="btn btn-sm toggle-view-btn" [class.active]="viewMode === 'chat'" (click)="viewMode = 'chat'">
            <i class="fa-brands fa-whatsapp me-1"></i> Chat View
          </button>
          <button class="btn btn-sm toggle-view-btn" [class.active]="viewMode === 'table'" (click)="viewMode = 'table'">
            <i class="fa-solid fa-table me-1"></i> Table View
          </button>
        </div>
        -->

        <!-- Report Mode Toggle -->
        <div class="report-toggle-pill">
          <button
            class="toggle-btn"
            [class.active]="reportType === 'chat'"
            (click)="onReportTypeChange('chat')"
          >
            <i class="fa-solid fa-comments"></i>
            <span>{{ 'whatsapp-conversation.mode-chats' | translate }}</span>
          </button>
          <button
            class="toggle-btn"
            [class.active]="reportType === 'tokens'"
            (click)="onReportTypeChange('tokens')"
          >
            <i class="fa-solid fa-coins"></i>
            <span>{{ 'whatsapp-conversation.mode-tokens' | translate }}</span>
          </button>
        </div>
      </div>
    </div>

    <!-- KPI Summary Cards -->
    <div class="kpi-grid">
      <div class="kpi-card">
        <div class="kpi-icon total">
          <i class="fa-solid fa-list-check"></i>
        </div>
        <div class="kpi-info">
          <span class="kpi-label">{{ 'whatsapp-conversation.kpi-total-logs' | translate }}</span>
          <span class="kpi-value">{{ summaryMetrics.totalLogs | number }}</span>
        </div>
      </div>

      <div class="kpi-card">
        <div class="kpi-icon inbound">
          <i class="fa-solid fa-arrow-down"></i>
        </div>
        <div class="kpi-info">
          <span class="kpi-label">{{ 'whatsapp-conversation.kpi-inbound' | translate }}</span>
          <span class="kpi-value">{{ summaryMetrics.inboundCount | number }}</span>
        </div>
      </div>

      <div class="kpi-card">
        <div class="kpi-icon outbound">
          <i class="fa-solid fa-arrow-up"></i>
        </div>
        <div class="kpi-info">
          <span class="kpi-label">{{ 'whatsapp-conversation.kpi-outbound' | translate }}</span>
          <span class="kpi-value">{{ summaryMetrics.outboundCount | number }}</span>
        </div>
      </div>

      <div class="kpi-card">
        <div class="kpi-icon tokens">
          <i class="fa-solid fa-bolt"></i>
        </div>
        <div class="kpi-info">
          <span class="kpi-label">{{ 'whatsapp-conversation.kpi-tokens' | translate }}</span>
          <span class="kpi-value">{{ summaryMetrics.totalTokens | number }}</span>
        </div>
      </div>
    </div>

    <!-- MODERN WHATSAPP WEB CHAT INTERFACE -->
    <div class="whatsapp-web-container" *ngIf="viewMode === 'chat'">
      <!-- Left Sidebar: Conversations list -->
      <div class="whatsapp-threads-sidebar">
        <div class="threads-header">
          <div class="threads-title">
            <i class="fa-brands fa-whatsapp text-success me-2 fs-5"></i>
            <span>{{ 'whatsapp-conversation.conversations' | translate }}</span>
          </div>
          <span class="threads-count-badge">{{ getGroupedPhoneThreads().length }} {{ 'whatsapp-conversation.threads' | translate }}</span>
        </div>

        <!-- Thread Search Bar -->
        <div class="threads-search-bar">
          <div class="search-input-box">
            <i class="fa-solid fa-magnifying-glass search-icon"></i>
            <input
              type="text"
              class="form-control"
              [placeholder]="'whatsapp-conversation.search-contacts' | translate"
              [(ngModel)]="threadSearchTerm"
            />
          </div>
        </div>

        <!-- Threads List -->
        <div class="threads-list">
          <div
            class="thread-item"
            *ngFor="let thread of getGroupedPhoneThreads()"
            [class.active]="activeChatPhone === thread.phone"
            (click)="selectPhoneThread(thread.phone)"
          >
            <div class="thread-avatar">
              <i class="fa-solid fa-user"></i>
            </div>

            <div class="thread-body">
              <div class="thread-top-row">
                <span class="thread-phone">{{ thread.phone }}</span>
                <span class="thread-time">{{ formatDateTime(thread.lastTime) }}</span>
              </div>
              <div class="thread-bottom-row">
                <span class="thread-company-badge">ID: {{ thread.companyId }}</span>
                <span class="thread-last-msg" [title]="thread.lastMessage">
                  {{ thread.lastMessage }}
                </span>
                <span class="thread-badge" *ngIf="!isThreadRead(thread.phone) && thread.count > 0">{{ thread.count }}</span>
              </div>
            </div>
          </div>

          <div class="empty-threads" *ngIf="getGroupedPhoneThreads().length === 0">
            <i class="fa-solid fa-comments text-muted fs-3 mb-2"></i>
            <p>{{ 'whatsapp-conversation.no-chats-found' | translate }}</p>
          </div>
        </div>
      </div>

      <!-- Right Main Chat Conversation Window -->
      <div class="whatsapp-chat-window">
        <!-- Chat Header -->
        <div class="chat-header" *ngIf="activeChatPhone">
          <div class="chat-header-user">
            <div class="chat-avatar">
              <i class="fa-solid fa-user"></i>
            </div>
            <div class="chat-user-details">
              <h5 class="chat-phone">{{ activeChatPhone }}</h5>
              <span class="chat-status">
                <i class="fa-solid fa-circle text-success me-1 online-dot"></i>
                {{ 'whatsapp-conversation.active-status' | translate }} • {{ 'whatsapp-conversation.company-id' | translate }}: {{ getSelectedThreadCompanyId() }}
              </span>
            </div>
          </div>

          <div class="chat-header-actions">
            <span class="tokens-summary-pill">
              <i class="fa-solid fa-bolt me-1 text-warning"></i>
              {{ summaryMetrics.totalTokens | number }} {{ 'whatsapp-conversation.tokens' | translate }}
            </span>
            <!--
            <button class="btn btn-light btn-sm ms-2" (click)="viewMode = 'table'" title="Switch to Table View">
              <i class="fa-solid fa-table me-1"></i> Table View
            </button>
            -->
          </div>
        </div>

        <!-- Messages Area with WhatsApp Chat Wallpaper -->
        <div class="chat-messages-area" *ngIf="activeChatPhone">
          <div class="chat-date-separator">
            <span>Today</span>
          </div>

          <div
            class="message-wrapper"
            *ngFor="let msg of getActiveThreadMessages()"
            [class.inbound-wrapper]="getDirection(msg).toLowerCase().includes('in')"
            [class.outbound-wrapper]="!getDirection(msg).toLowerCase().includes('in')"
          >
            <!-- Sender Avatar Circle (Outside Bubble on Left) -->
            <div class="msg-avatar-circle" *ngIf="getDirection(msg).toLowerCase().includes('in')">
              <span class="msg-avatar-text">{{ getSenderInitials(msg) }}</span>
            </div>

            <!-- Message Bubble -->
            <div
              class="message-bubble"
              [class.inbound-bubble]="getDirection(msg).toLowerCase().includes('in')"
              [class.outbound-bubble]="!getDirection(msg).toLowerCase().includes('in')"
              (click)="openDetailDrawer(msg)"
              title="Click to inspect raw JSON payload"
            >
              <!-- WhatsApp Sender Header: Name + Phone -->
              <div class="message-sender-line" *ngIf="getDirection(msg).toLowerCase().includes('in')">
                <span class="sender-display-name">{{ getSenderName(msg) }}</span>
                <span class="sender-phone-sub" *ngIf="getPhone(msg) !== '-'">+{{ getPhone(msg) }}</span>
              </div>

              <!-- Message Body Text -->
              <div class="bubble-text">
                {{ getMessageText(msg) }}
              </div>

              <!-- Footer: Timestamp + Tokens + Status Checkmarks -->
              <div class="bubble-footer">
                <span class="token-tag" *ngIf="msg.tokens_used">
                  <i class="fa-solid fa-coins me-1"></i>{{ msg.tokens_used }}
                </span>
                <span class="bubble-time">{{ formatDateTime(msg.created_at || msg.timestamp) }}</span>
                <span class="bubble-checks" *ngIf="!getDirection(msg).toLowerCase().includes('in')">
                  <i class="fa-solid fa-check-double text-primary"></i>
                </span>
                <span class="bubble-checks" *ngIf="getDirection(msg).toLowerCase().includes('in')">
                  <i class="fa-solid fa-check text-muted"></i>
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Empty / No Selection State -->
        <div class="no-chat-selected" *ngIf="!activeChatPhone">
          <i class="fa-brands fa-whatsapp text-success display-1 mb-3"></i>
          <h4>WhatsApp Conversation Log</h4>
          <p class="text-muted">Select a contact thread from the left sidebar to view live chat messages.</p>
        </div>

        <!-- Chat Interactive Input Footer Bar commented out per user request -->
        <!--
        <div class="chat-footer-bar" *ngIf="activeChatPhone">
          <div class="footer-icon-wrapper">
            <i class="fa-regular fa-face-smile footer-icon" (click)="toggleEmojiPicker()" title="Insert Emoji"></i>

            <div class="emoji-picker-popover" *ngIf="emojiPickerVisible">
              <div class="emoji-search-box p-1 border-bottom">
                <input
                  type="text"
                  class="form-control form-control-sm border-0 shadow-none bg-light"
                  placeholder="Search emoji..."
                  [(ngModel)]="emojiSearchTerm"
                />
              </div>

              <div class="emoji-tabs-bar">
                <button
                  class="emoji-tab-btn"
                  *ngFor="let cat of emojiCategories"
                  [class.active]="emojiCategory === cat.id"
                  (click)="emojiCategory = cat.id; emojiSearchTerm = ''"
                  [title]="cat.label"
                >
                  <span>{{ cat.icon }}</span>
                </button>
              </div>

              <div class="emoji-grid-scroll">
                <span
                  class="emoji-item"
                  *ngFor="let e of getFilteredEmojis()"
                  (click)="addEmoji(e)"
                >
                  {{ e }}
                </span>
              </div>
            </div>
          </div>

          <div class="footer-icon-wrapper me-2">
            <i class="fa-solid fa-paperclip footer-icon" (click)="toggleAttachmentMenu()" title="Attach Entry / Document"></i>

            <div class="attachment-menu-popover" *ngIf="attachmentMenuVisible">
              <button class="attachment-option-btn image-opt" (click)="sendQuickAttachment('image')">
                <i class="fa-solid fa-image me-2"></i> Send Receipt Image
              </button>
              <button class="attachment-option-btn doc-opt" (click)="sendQuickAttachment('document')">
                <i class="fa-solid fa-file-pdf me-2"></i> Send Claim Voucher
              </button>
              <button class="attachment-option-btn code-opt" (click)="sendQuickAttachment('code')">
                <i class="fa-solid fa-ticket me-2"></i> Submit Campaign Code
              </button>
            </div>
          </div>

          <div class="footer-input-box">
            <input
              type="text"
              class="form-control"
              placeholder="Type a message to communicate with WhatsApp..."
              [(ngModel)]="newMessageText"
              (keyup.enter)="sendSimulatedMessage()"
            />
          </div>

          <div class="send-btn" (click)="sendSimulatedMessage()" title="Send Message">
            <i class="fa-solid fa-paper-plane"></i>
          </div>
        </div>
        -->
      </div>
    </div>

    <!-- DATA TABLE VIEW (Only shown when viewMode === 'table') -->
    <div class="table-card" *ngIf="viewMode === 'table'">

    <!-- REPORT: CHAT LOGS TABLE -->
    <ng-container *ngIf="reportType === 'chat'">
      <nz-table
        #chatTable
        [nzData]="items"
        [nzLoading]="loading"
        [nzFrontPagination]="false"
        [nzTotal]="totalItems"
        [nzPageIndex]="currentPage"
        [nzPageSize]="pageSize"
        (nzPageIndexChange)="onPageIndexChange($event)"
        (nzPageSizeChange)="onPageSizeChange($event)"
        [nzShowSizeChanger]="true"
        [nzPageSizeOptions]="[10, 25, 50, 100]"
        class="luqta-table"
      >
        <thead>
          <tr>
            <th>{{ 'whatsapp-conversation.col-date' | translate }}</th>
            <th>{{ 'whatsapp-conversation.col-phone' | translate }}</th>
            <th>{{ 'whatsapp-conversation.col-company-id' | translate }}</th>
            <th>{{ 'whatsapp-conversation.col-direction' | translate }}</th>
            <th>{{ 'whatsapp-conversation.col-intent' | translate }}</th>
            <th>{{ 'whatsapp-conversation.col-message' | translate }}</th>
            <th class="text-end">{{ 'whatsapp-conversation.col-actions' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of chatTable.data">
            <td class="date-cell">
              {{ formatDateTime(row.created_at || row.createdAt || row.timestamp) }}
            </td>
            <td>
              <button
                class="btn-phone-link"
                (click)="openPhoneChatThread(getPhone(row))"
                [title]="'whatsapp-conversation.filter-this-phone' | translate"
              >
                <i class="fa-brands fa-whatsapp me-1"></i>
                {{ getPhone(row) }}
              </button>
            </td>
            <td>
              <span class="badge-company">
                ID: {{ getCompanyId(row) }}
              </span>
            </td>
            <td>
              <span class="direction-badge" [ngClass]="getDirectionClass(getDirection(row))">
                <i class="fa-solid" [ngClass]="getDirection(row).toLowerCase().includes('in') ? 'fa-arrow-down' : 'fa-arrow-up'"></i>
                {{ getDirection(row) | uppercase }}
              </span>
            </td>
            <td>
              <div class="intent-tags">
                <span class="tag-intent" *ngIf="row.intent">{{ row.intent }}</span>
                <span class="tag-category" *ngIf="row.category">{{ row.category }}</span>
                <span *ngIf="!row.intent && !row.category" class="text-muted">-</span>
              </div>
            </td>
            <td class="message-preview-cell">
              <span class="message-text" [title]="getMessageText(row)">
                {{ getMessageText(row) }}
              </span>
            </td>
            <td class="text-end">
              <button
                class="btn-icon"
                (click)="openDetailDrawer(row)"
                [nzTooltipTitle]="'whatsapp-conversation.inspect-details' | translate"
                nz-tooltip
              >
                <i class="fa-solid fa-eye"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </ng-container>

    <!-- REPORT: TOKEN USAGE TABLE -->
    <ng-container *ngIf="reportType === 'tokens'">
      <nz-table
        #tokenTable
        [nzData]="items"
        [nzLoading]="loading"
        [nzFrontPagination]="false"
        [nzTotal]="totalItems"
        [nzPageIndex]="currentPage"
        [nzPageSize]="pageSize"
        (nzPageIndexChange)="onPageIndexChange($event)"
        (nzPageSizeChange)="onPageSizeChange($event)"
        [nzShowSizeChanger]="true"
        [nzPageSizeOptions]="[10, 25, 50, 100]"
        class="luqta-table"
      >
        <thead>
          <tr>
            <th>{{ 'whatsapp-conversation.col-user-company' | translate }}</th>
            <th>{{ 'whatsapp-conversation.col-phone' | translate }}</th>
            <th>{{ 'whatsapp-conversation.col-tokens-used' | translate }}</th>
            <th>{{ 'whatsapp-conversation.col-prompt-tokens' | translate }}</th>
            <th>{{ 'whatsapp-conversation.col-completion-tokens' | translate }}</th>
            <th>{{ 'whatsapp-conversation.col-total-messages' | translate }}</th>
            <th class="text-end">{{ 'whatsapp-conversation.col-actions' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of tokenTable.data">
            <td>
              <div class="user-company-cell">
                <span class="main-title">{{ row.user_name || row.company_name || ('User #' + (row.user_id || row.company_id || 'N/A')) }}</span>
                <span class="sub-id">Company ID: {{ row.company_id || '-' }} | User ID: {{ row.user_id || '-' }}</span>
              </div>
            </td>
            <td>
              <span class="phone-text" *ngIf="getPhone(row) !== '-'">
                <i class="fa-brands fa-whatsapp me-1 text-success"></i> {{ getPhone(row) }}
              </span>
              <span *ngIf="getPhone(row) === '-'" class="text-muted">-</span>
            </td>
            <td>
              <span class="token-badge highlight">
                <i class="fa-solid fa-coins me-1"></i>
                {{ (row.total_tokens || row.tokens_used || row.tokens || 0) | number }}
              </span>
            </td>
            <td>{{ (row.prompt_tokens || 0) | number }}</td>
            <td>{{ (row.completion_tokens || 0) | number }}</td>
            <td>
              <span class="badge-count">{{ (row.total_messages || row.message_count || 1) | number }}</span>
            </td>
            <td class="text-end">
              <button
                class="btn-icon"
                (click)="openDetailDrawer(row)"
                [nzTooltipTitle]="'whatsapp-conversation.inspect-details' | translate"
                nz-tooltip
              >
                <i class="fa-solid fa-eye"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </ng-container>

  </div>
</div>

<!-- Raw Payload Inspection Drawer -->
<nz-drawer
  [nzVisible]="drawerVisible"
  [nzWidth]="520"
  [nzTitle]="drawerTitle"
  (nzOnClose)="closeDrawer()"
>
  <ng-template #drawerTitle>
    <div class="drawer-header-title">
      <i class="fa-brands fa-whatsapp text-success me-2"></i>
      <span>{{ 'whatsapp-conversation.log-details' | translate }}</span>
    </div>
  </ng-template>

  <ng-container *nzDrawerContent>
    <div class="drawer-content-body" *ngIf="selectedItem">
      <!-- Main Summary Box -->
      <div class="detail-summary-card">
        <div class="summary-item">
          <span class="label">{{ 'whatsapp-conversation.col-phone' | translate }}:</span>
          <span class="value font-mono">{{ getPhone(selectedItem) }}</span>
        </div>
        <div class="summary-item" *ngIf="selectedItem.direction">
          <span class="label">{{ 'whatsapp-conversation.col-direction' | translate }}:</span>
          <span class="direction-badge" [ngClass]="getDirectionClass(getDirection(selectedItem))">
            {{ getDirection(selectedItem) | uppercase }}
          </span>
        </div>
        <div class="summary-item">
          <span class="label">{{ 'whatsapp-conversation.col-date' | translate }}:</span>
          <span class="value">{{ formatDateTime(selectedItem.created_at || selectedItem.timestamp) }}</span>
        </div>
      </div>

      <!-- Message Text Box -->
      <div class="message-box" *ngIf="getMessageText(selectedItem) !== '-'">
        <h6>{{ 'whatsapp-conversation.message-body' | translate }}</h6>
        <p class="message-body-full">{{ getMessageText(selectedItem) }}</p>
      </div>

      <!-- Raw Payload Table -->
      <div class="raw-entries-section">
        <h6>{{ 'whatsapp-conversation.raw-payload' | translate }}</h6>
        <table class="table table-bordered table-sm raw-table">
          <thead>
            <tr>
              <th>Field</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let entry of rawEntries">
              <td class="field-key font-mono">{{ entry.key }}</td>
              <td class="field-val">
                <pre *ngIf="entry.value.includes('\n') || entry.value.startsWith('{')" class="json-pre">{{ entry.value }}</pre>
                <span *ngIf="!entry.value.includes('\n') && !entry.value.startsWith('{')">{{ entry.value }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ng-container>
</nz-drawer>

<!-- Filter Options Modal (Luqta Custom Modal) -->
<nz-modal
  nzClassName="luqta-custom-modal"
  [(nzVisible)]="filterDrawerVisible"
  [nzTitle]="'Filter Conversations'"
  [nzFooter]="modalFooter"
  (nzOnCancel)="closeFilterDrawer()"
  nzWidth="680px"
>
  <ng-container *nzModalContent>
    <div class="filter-form py-2">
      <div class="row gy-3">
        <!-- Phone Filter (Dropdown) -->
        <div class="col-md-6">
          <label class="form-label font-weight-bold">{{ 'whatsapp-conversation.filter-phone' | translate }}</label>
          <nz-select
            [(ngModel)]="phoneFilter"
            [nzPlaceHolder]="'whatsapp-conversation.all' | translate"
            [nzShowSearch]="true"
            [nzAllowClear]="true"
            class="filter-select w-100"
           [nzOptionOverflowSize]="5">
            <nz-option nzValue="" [nzLabel]="'whatsapp-conversation.all' | translate"></nz-option>
            <nz-option
              *ngFor="let phone of getAvailablePhoneNumbers()"
              [nzValue]="phone"
              [nzLabel]="phone"
            ></nz-option>
          </nz-select>
        </div>

        <!-- Company ID Filter commented out per user request -->
        <!--
        <div class="col-md-6">
          <label class="form-label font-weight-bold">{{ 'whatsapp-conversation.filter-company' | translate }}</label>
          <input
            type="number"
            class="form-control filter-input"
            placeholder="e.g. 78"
            [(ngModel)]="companyIdFilter"
          />
        </div>
        -->

        <!-- Direction, Intent, Date From & Date To filters commented out per user request -->
        <!--
        <div class="col-md-6" *ngIf="reportType === 'chat'">
          <label class="form-label font-weight-bold">{{ 'whatsapp-conversation.filter-direction' | translate }}</label>
          <nz-select
            [(ngModel)]="directionFilter"
            [nzPlaceHolder]="'whatsapp-conversation.all' | translate"
            class="filter-select w-100"
          >
            <nz-option nzValue="" [nzLabel]="'whatsapp-conversation.all' | translate"></nz-option>
            <nz-option nzValue="inbound" [nzLabel]="'whatsapp-conversation.inbound' | translate"></nz-option>
            <nz-option nzValue="outbound" [nzLabel]="'whatsapp-conversation.outbound' | translate"></nz-option>
          </nz-select>
        </div>

        <div class="col-md-6" *ngIf="reportType === 'chat'">
          <label class="form-label font-weight-bold">{{ 'whatsapp-conversation.col-intent' | translate }}</label>
          <input
            type="text"
            class="form-control filter-input"
            placeholder="e.g. contest_query"
            [(ngModel)]="intentFilter"
          />
        </div>

        <div class="col-md-6">
          <label class="form-label font-weight-bold">{{ 'whatsapp-conversation.filter-date-from' | translate }}</label>
          <nz-date-picker
            [(ngModel)]="dateFrom"
            [nzPlaceHolder]="'whatsapp-conversation.date-from' | translate"
            class="w-100"
            nzFormat="yyyy-MM-dd"
          ></nz-date-picker>
        </div>

        <div class="col-md-6">
          <label class="form-label font-weight-bold">{{ 'whatsapp-conversation.filter-date-to' | translate }}</label>
          <nz-date-picker
            [(ngModel)]="dateTo"
            [nzPlaceHolder]="'whatsapp-conversation.date-to' | translate"
            class="w-100"
            nzFormat="yyyy-MM-dd"
          ></nz-date-picker>
        </div>
        -->
      </div>
    </div>
  </ng-container>

  <ng-template #modalFooter>
    <div class="d-flex justify-content-between align-items-center w-100">
      <button type="button" class="btn" (click)="clearFilters(); closeFilterDrawer()" style="background-color: #1f2430; color: #ffffff; border: none; border-radius: 8px; padding: 10px 22px; font-weight: 500;">
        Reset Filters
      </button>
      <button nz-button nzType="primary" class="btn btn-primary" (click)="applyFilters()">
        Apply Filters
      </button>
    </div>
  </ng-template>
</nz-modal>
